import { apiGet, apiPost } from "./client";
import type { IInvoice } from "../types/Invoice";

export type InvoiceCandidate = {
  orderId: string;
  orderNumber: string;
  completedAt: string;
  customerId: string;
  customerName: string;
  companyId?: string;
  companyName?: string;
  error?: string;
};
export type InvoiceReview = {
  reviewToken: string;
  invoice: IInvoice;
  maxOrders: number;
};

export async function getInvoiceCandidates(
  token: string,
  workspaceId: string,
  customerId?: string,
  cursor?: string,
) {
  const params = new URLSearchParams();
  if (customerId) params.set("customerId", customerId);
  if (cursor) params.set("cursor", cursor);
  return (await apiGet(token, `/api/invoices/ready?${params}`, workspaceId))
    .data as {
    orders: InvoiceCandidate[];
    nextCursor: string | null;
  };
}

export async function reviewConsolidatedInvoice(
  token: string,
  workspaceId: string,
  orderIds: string[],
) {
  return (
    await apiPost(
      token,
      "/api/invoices/consolidated/preview",
      { orderIds },
      workspaceId,
    )
  ).data as InvoiceReview;
}

export async function createConsolidatedInvoice(
  token: string,
  workspaceId: string,
  orderIds: string[],
  reviewToken: string,
  requestId: string,
) {
  return (
    await apiPost(
      token,
      "/api/invoices/consolidated",
      { orderIds, reviewToken, requestId },
      workspaceId,
    )
  ).data as { invoice: IInvoice; created: boolean };
}
